import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FilterLeistungStatusPipe pipe.
 *
 * See https://angular.io/docs/ts/latest/guide/pipes.html for more info on
 * Angular Pipes.
 */
@Pipe({
  name: 'filterLeistungStatus',
})
export class FilterLeistungStatusPipe implements PipeTransform {
  /**
   * Takes a value and makes it lowercase.
   */
  transform(value: any[], status:any) {
   // filter items array, items which match and return true will be kept, false will be filtered out
       
       //return items.filter(item => item.lastname.indexOf(args['lastname']) !== -1);
       //var r = new RegExp(status, 'i');

       var stat =  JSON.parse(status);
       return value.filter(item => item.Verrechnet == stat);

    //return value;
  }
}



// WEBPACK FOOTER //
// ./src/pipes/filter-leistung-status/filter-leistung-status.ts